import { computed, ref } from "vue";
import { WindowDimensions } from "@/shared/eventPayloads";
import { mobileBreakpoint } from "@/shared/helpers";
import { canUseLocalstorage } from "@/util/localstorage";

const useLocalstorage = canUseLocalstorage();

const snd = new Audio("sounds/pop.mp3");
const widgetId = ref<string>();
const name = ref<string>();
const visitorId = ref<string>();
const isPreviewMode = ref(false);
const visitorCountryCode = ref<string>();
const windowDimensions = ref<WindowDimensions>({
  height: window.innerHeight,
  width: window.innerWidth,
});

if (useLocalstorage) {
  const cachedVisitorCountry = window.localStorage.getItem(
    "chat-visitor-country"
  );

  if (cachedVisitorCountry) {
    visitorCountryCode.value = cachedVisitorCountry;
  }
}

const setVisitorId = (visitorIdStr: string) => {
  visitorId.value = visitorIdStr;

  // Persist visitorId to storage
  if (useLocalstorage) {
    if (!widgetId.value) {
      throw new Error(
        "Tried to set visitor ID, but there is no known widgetId yet"
      );
    }

    window.localStorage.setItem(`${widgetId.value}_visitorId`, visitorIdStr);
  }
};

const setWidgetId = (id: string) => {
  widgetId.value = id;

  // Read visitorId from storage
  if (useLocalstorage) {
    const visitorId = window.localStorage.getItem(`${id}_visitorId`);

    if (visitorId) {
      console.debug("got visitorId from storage:", visitorId);
      setVisitorId(visitorId);
    }
  }
};

const setWindowDimensions = (dimensions: WindowDimensions) => {
  windowDimensions.value = dimensions;
};

const setPreviewMode = () => {
  isPreviewMode.value = true;
  visitorId.value = undefined;
  widgetId.value = undefined;
};

const setVisitorCountryCode = (countryCode: string) => {
  visitorCountryCode.value = countryCode;

  if (useLocalstorage) {
    window.localStorage.setItem("chat-visitor-country", countryCode);
  }
};

const playChime = async () => await snd.play();

// const throttledTyping = useThrottleFn(async (text: string) => {
//   await axios.post(process.env.VUE_APP_TYPING_ENDPOINT as string, {
//     channelId: channelId.value,
//     text: text
//   })
// }, 2000)

export function useApp() {
  if (process.env.VUE_APP_PREVIEW_MODE === "true") {
    isPreviewMode.value = true;
  }

  if (
    !visitorId.value &&
    process.env.VUE_APP_FAKE_VISITOR_ID &&
    process.env.NODE_ENV !== "production" &&
    !isPreviewMode.value
  ) {
    setVisitorId(process.env.VUE_APP_FAKE_VISITOR_ID);
  }

  if (
    !widgetId.value &&
    process.env.VUE_APP_WIDGET_ID &&
    process.env.NODE_ENV !== "production" &&
    !isPreviewMode.value
  ) {
    setWidgetId(process.env.VUE_APP_WIDGET_ID);
  }

  const typing = ref<boolean>(false);
  //let typingTimer = 0
  const doneTypingInterval = 5000;

  // const onStoppedTyping = async () => {
  //   typing.value = false
  //
  //   await axios.delete(
  //     `${process.env.VUE_APP_TYPING_ENDPOINT}?channelId=${channelId.value}`
  //   )
  // }
  //
  // const onTyping = async (text: string) => {
  //   clearTimeout(typingTimer)
  //   typingTimer = window.setTimeout(onStoppedTyping, doneTypingInterval)
  //
  //   if (!typing.value) {
  //     typing.value = true
  //   }
  //
  //   await throttledTyping(text);
  // }

  return {
    playChime,
    //onTyping,
    setWidgetId,
    name,
    setVisitorId,
    setVisitorCountryCode,
    setWindowDimensions,
    setPreviewMode,

    visitorId: computed(() => visitorId.value),
    visitorCountryCode: computed(() => visitorCountryCode.value),
    windowDimensions: computed(() => windowDimensions.value),
    useMobileLayout: computed(
      () => windowDimensions.value.width <= mobileBreakpoint
    ),
    widgetId: computed(() => widgetId.value),
    isPreviewMode: computed(() => isPreviewMode.value),
  };
}
